// Copyright (c) 2020-2021 Visual Intelligence LP. All rights reserved.
//
import { observable, action, makeObservable } from 'mobx';

import { ProfileStatus } from '@shared/constants/user';

// Interface to exchange user profile data with portal-api.
export interface CustomerUserDTO {
  id: number;
  email: string;
  fullName: string;
  title: string;
  profilePhoto: string;
  profileStatus: ProfileStatus;
  lastActivityDate: string;
  isBlocked?: boolean;
  isActive?: boolean;
  roles?: Array<string>; // TODO remove after API doesn't need this
}

// Wrapper class for the CustomerUserDTO.
export class CustomerUser {
  id: number;
  email: string;
  fullName: string;
  title: string;
  profilePhoto: string;
  profileStatus: ProfileStatus;
  lastActivityDate: string;
  @observable isBlocked: boolean;
  @observable isActive: boolean;
  roles: Array<string>;

  constructor(dto: CustomerUserDTO) {
    this.update(dto);
    makeObservable(this);
  }

  get asJson(): CustomerUserDTO {
    return {
      id: this.id,
      email: this.email,
      fullName: this.fullName,
      title: this.title,
      profilePhoto: this.profilePhoto,
      profileStatus: this.profileStatus,
      lastActivityDate: this.lastActivityDate,
      isBlocked: this.isBlocked,
      isActive: this.isActive,
      roles: this.roles
    };
  }

  @action update(newData: Partial<CustomerUserDTO>): CustomerUserDTO {
    const allData = { ...this.asJson, ...newData };

    Object.assign(this, allData);

    return this.asJson;
  }
}
